export const GLOBAL_PLAN_COUNTRY = { code: "US", value: "Global" };
export const PLAN_COUNTRIES = [
    { code: "NZ", value: "New Zealand" },
    { code: 'AU', value: "Australia" },
    { code: 'GB', value: "United Kingdom" },
    GLOBAL_PLAN_COUNTRY,
];

export const getIsCountryMatchingPlanCountry = (countryCode: string, planCode: string) => {
    countryCode = countryCode.toUpperCase();
    planCode = planCode.toUpperCase();

    const nonGlobalPlanCountries = PLAN_COUNTRIES
        .filter(c => c.value !== GLOBAL_PLAN_COUNTRY.value);

    const globalCountryCode = GLOBAL_PLAN_COUNTRY.code;

    const shouldCountryCodeHaveGlobalPlan = nonGlobalPlanCountries
        .every(c => c.code !== countryCode);

    return planCode === globalCountryCode ?
        shouldCountryCodeHaveGlobalPlan :
        countryCode === planCode;
}

export const getPlanStoreNameFromCode = (countryCode: string, defaultToGlobal: boolean = true) => {
    const countryCodeName = PLAN_COUNTRIES
        .find((country) => country.code === countryCode)?.value;

    if (!countryCodeName && defaultToGlobal) {
        return GLOBAL_PLAN_COUNTRY.value;
    }

    return countryCodeName;
}
